import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as yup from 'yup'

const EditAboutMemberModal = ({ isOpen, onClose, data, onSubmit }) => {
  const validationSchema = yup.object().shape({
    name_en: yup.string().required('English name is required'),
    name_ka: yup.string().required('Georgian name is required'),
    position_en: yup.string().required('English position is required'),
    position_ka: yup.string().required('Georgian position is required'),
    location_en: yup.string(),
    location_ka: yup.string(),
    imageUrl: yup.mixed().required('Image is required'),
    sortOrder: yup.number(),
  })

  const initialValues = {
    name_en: data?.name_en || '',
    name_ka: data?.name_ka || '',
    position_en: data?.position_en || '',
    position_ka: data?.position_ka || '',
    location_en: data?.location_en || '',
    location_ka: data?.location_ka || '',
    imageUrl: data?.imageUrl || null,
    sortOrder: data?.sortOrder || null,
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>რედაქტირება</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initialValues}
          onSubmit={(values, { setSubmitting }) => {
            onSubmit(values, { setSubmitting })
          }}
          validationSchema={validationSchema}
        >
          {({ setFieldValue, isSubmitting }) => (
            <Form>
              <div className='flex flex-col gap-4 p-3.5'>
                {[
                  ['name_en', 'სახელი (EN)'],
                  ['name_ka', 'სახელი (KA)'],
                  ['position_en', 'პოზიცია (EN)'],
                  ['position_ka', 'პოზიცია (KA)'],
                  ['location_en', 'მდებარეობა (EN)'],
                  ['location_ka', 'მდებარეობა (KA)'],
                  ['sortOrder', 'რიგი'],
                ].map(([field, label]) => (
                  <span key={field}>
                    <label htmlFor={field} className='text-lg'>
                      {label}
                    </label>
                    <Field
                      className='border rounded py-2 px-2 w-full'
                      autoComplete='off'
                      type='text'
                      name={field}
                      placeholder={label}
                    />
                    <ErrorMessage
                      style={{ color: 'red', fontSize: '14px' }}
                      name={field}
                      component='span'
                    />
                  </span>
                ))}
                <div>
                  <label htmlFor='imageUrl' className='text-lg'>
                    პროფილის ფოტო
                  </label>
                  <Field name='imageUrl'>
                    {({ form }) => (
                      <input
                        type='file'
                        accept='image/*'
                        onChange={event => {
                          const file = event.currentTarget.files[0]
                          form.setFieldValue('imageUrl', file)
                        }}
                      />
                    )}
                  </Field>
                  <ErrorMessage
                    name='imageUrl'
                    component='span'
                    style={{ color: 'red', fontSize: '14px' }}
                  />
                </div>

                <div className='flex flex-row items-center gap-3 justify-end w-full'>
                  <Button variant='primary' type='submit' disabled={isSubmitting}>
                    შენახვა
                  </Button>
                  <Button variant='secondary' onClick={onClose}>
                    Cancel
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default EditAboutMemberModal
